export default "__VITE_ASSET__42ca309d__"